let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fS5Pj")).then(() => parcelRequire('cuAUS'));